// Раздел «Кухня»: вкладки «Заказы» | «Стоп-лист» (отдельного пункта навигации у стоп-листа нет).
// Вкладка — в адресе (/kitchen?tab=stoplist): переживает обновление страницы и «назад». Неактивная вкладка
// не смонтирована — её запросы и опрос не идут. Переключатель вкладка ставит в закреплённую панель под строкой
// «ресторан + колокольчик» — тот же порядок, что на других экранах.
import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SegmentedTabs, { panelDomId, tabDomId } from '../../components/SegmentedTabs';
import { SECTION_ACCENTS } from '../../styles/tokens';
import KitchenLoadTab from './KitchenLoadTab';
import StopListTab from './StopListTab';

const ACCENT = SECTION_ACCENTS['/kitchen'];
const TABS = [
  { value: 'load', label: 'Заказы', icon: ReceiptLongOutlinedIcon },
  { value: 'stoplist', label: 'Стоп-лист', icon: BlockOutlinedIcon },
];
const TABS_ID = 'kitchen-tabs';
const PANELS = 'kitchen-panel';

export default function KitchenPage(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'stoplist' ? 'stoplist' : 'load';

  const changeTab = (value) => {
    const next = new URLSearchParams(searchParams);
    if (value === 'load') next.delete('tab');
    else next.set('tab', value);
    setSearchParams(next);
  };

  const tabs = (
    <SegmentedTabs id={TABS_ID} controls={PANELS} tabs={TABS} value={tab} onChange={changeTab} accent={ACCENT} label="Раздел «Кухня»" />
  );

  return (
    <Box
      role="tabpanel"
      id={panelDomId(PANELS, tab)}
      aria-labelledby={tabDomId(TABS_ID, tab)}
      sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
    >
      {tab === 'stoplist' ? <StopListTab {...props} tabs={tabs} /> : <KitchenLoadTab {...props} tabs={tabs} />}
    </Box>
  );
}
